import { Color } from "../types";

export const bathroomTiles = (color: Color) => ({
  background: `radial-gradient(${color}aa 3px, transparent 2px) 0px 0px / 10px 10px,
  repeating-radial-gradient(${color}bb 0px, ${color} 8px, transparent 2px, transparent 9px,${color}dd 7px, ${color}cc 7px, transparent 6px, transparent 15px) 0% 0% / 30px 30px`,
});
